import {injectable} from 'inversify';

import type {ChoiceQuestionModel} from '../../Question/ChoiceQuestion/ChoiceQuestion.model';
import type {AnswerModelProps} from '../Answer.model';

import {MultipleChoiceAnswerModel} from './MultipleChoiceAnswer.model';

@injectable()
export class MultipleChoiceAnswerFactory {
  create(props: AnswerModelProps<string, ChoiceQuestionModel>) {
    return new MultipleChoiceAnswerModel(props);
  }
}
